function checkboxToggler() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./checkbox-toggler.html'),
    scope: {},
    controller: 'CheckboxTogglerController',
    controllerAs: 'vm',
    bindToController: {
      isChecked: '=',
      isFiltered: '=',
      onClick: '&'
    }
  };
}

function CheckboxTogglerController($scope, Helper, CheckboxToggler) {
  'ngInject';
  const vm = this;

  vm.toggleLabel = '';

  vm.onCheckboxChange = onCheckboxChange;

  $scope.$watch('[vm.isFiltered, vm.isChecked]', _onFilterChange);

  function _onFilterChange() {

    vm.toggleLabel = CheckboxToggler.getToggleLabel(vm.isChecked, vm.isFiltered);

  }

  function onCheckboxChange() {

    Helper.ready(() => vm.onClick({checked: vm.isChecked}));

  }

}

export { CheckboxTogglerController, checkboxToggler };
